import { render, staticRenderFns } from "./FlightInfo.vue?vue&type=template&id=5ffad5de&scoped=true&"
import script from "./FlightInfo.vue?vue&type=script&lang=js&"
export * from "./FlightInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlightInfo.vue?vue&type=style&index=0&id=5ffad5de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffad5de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout,VProgressCircular})
